import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import media from 'css-in-js-media'

export const ToggleWrap = styled.div`
    display: inline-block;
    svg {
        vertical-align: top;
    }
    ${media('<desktop')} {
        svg {
            width: 25px;
            height: 25px;
        }
    }
`

export default function Toggle({ open }) {
    const label = open ? 'Expend' : 'Collapse'
    return (
        <>
            <ToggleWrap>
                {open ? (
                    <SVG
                        aria={label}
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.6875 15H25.3125"
                            stroke="black"
                            strokeWidth="1.875"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </SVG>
                ) : (
                    <SVG
                        aria={label}
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M4.6875 15H25.3125"
                            stroke="black"
                            strokeWidth="1.875"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M15 4.6875V25.3125"
                            stroke="black"
                            strokeWidth="1.875"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </SVG>
                )}
            </ToggleWrap>
        </>
    )
}

Toggle.defaultProps = {
    open: false,
}

Toggle.propTypes = {
    open: PropTypes.bool,
}

const SVG = styled.svg.attrs((props) => ({
    'aria-label': props.aria,
}))``
